import Vue from 'vue'
import App from './App.vue'
import store from './store'
import i18n from '@/shared/i18n'
import router from './router'

Vue.config.productionTip = false

// bootstrap-vue
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

// Axios
import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;
axios.defaults.headers.common.Accept = 'application/json';
axios.interceptors.response.use(
    response => response,
    (error) => {
        return Promise.reject(error);
    }
);

// Mixins
import CommonMixin from '@/shared/mixins/CommonMixin'
Vue.mixin(CommonMixin);

// Global components
import InfoButton from '@/shared/components/forms/InfoButton.vue'
import MandatoryFlag from '@/shared/components/forms/MandatoryFlag.vue'
import VueRender from '@/shared/components/VueRender.vue'

Vue.component('info-button', InfoButton)
Vue.component('mandatory-flag', MandatoryFlag)
Vue.component('vue-render', VueRender)

new Vue({
    router, 
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
